import { Preferences } from '@capacitor/preferences'

export type SupportedLocale = 'en' | 'pl'

const LANGUAGE_KEY = 'app_language'
const DEFAULT_LANGUAGE: SupportedLocale = 'en'

export class LanguageService {
  static async getStoredLanguage(): Promise<SupportedLocale> {
    try {
      const result = await Preferences.get({ key: LANGUAGE_KEY })
      const storedLanguage = result.value as SupportedLocale

      if (storedLanguage && ['en', 'pl'].includes(storedLanguage)) {
        return storedLanguage
      }
    } catch (error) {
      console.warn('Failed to get stored language:', error)
    }

    return DEFAULT_LANGUAGE
  }

  static async setLanguage(language: SupportedLocale): Promise<void> {
    try {
      await Preferences.set({
        key: LANGUAGE_KEY,
        value: language,
      })
    } catch (error) {
      console.error('Failed to store language preference:', error)
      throw error
    }
  }

  static async clearLanguage(): Promise<void> {
    try {
      await Preferences.remove({ key: LANGUAGE_KEY })
    } catch (error) {
      console.error('Failed to clear language preference:', error)
      throw error
    }
  }

  static getAvailableLanguages(): Array<{ code: SupportedLocale, name: string, nativeName: string }> {
    return [
      { code: 'en', name: 'English', nativeName: 'English' },
      { code: 'pl', name: 'Polish', nativeName: 'Polski' },
    ]
  }

  static isSupported(code: string): code is SupportedLocale {
    return code === 'en' || code === 'pl'
  }
}